import { SystemText } from '@salesperformanceint/e4shared';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadUserFromAzure } from '../../../actions/user';
import { msalInstance, msalScope } from '../../../helpers/azure';

export const Azure = () => {
    const dispatch = useDispatch();

    const error = useSelector(state => state.user.errorMessage);

    React.useEffect(() => {
        if (msalInstance?.getAccount()) {
            msalInstance
                .acquireTokenSilent(msalScope)
                .then(res => {
                    // set token in sessionStorage
                    const { accessToken, expiresOn } = res;
                    sessionStorage.setItem('access_token', accessToken);
                    sessionStorage.setItem('token_expiration', expiresOn);

                    // get user info from graph api
                    window.opener.postMessage(res);
                    window.close();
                })
                .catch(err => {
                    console.error(err);
                    msalInstance.loginRedirect(msalScope);
                });
        } else {
            msalInstance.loginRedirect(msalScope);
        }
    }, []);

    if (error)
        return (
            <div className="flex flex-center flex-column">
                <h3 id="WelcomeMessage">{SystemText('Admin/Forms/FilePicker/OneDrive/Title')}</h3>
                <div>
                    <span id="json">{error}</span>
                </div>
            </div>
        );

    return (
        <div className="flex flex-center flex-column">
            <h3 id="WelcomeMessage">{SystemText('Admin/Forms/FilePicker/OneDrive/Title')}</h3>
            <div>
                <i className="fa fa-spin fa-cog text-lg mr10" />
                <span id="json">{SystemText('Admin/Forms/FilePicker/OneDrive/Wait')}</span>
            </div>
        </div>
    );
};

export default Azure;
